export function checkRole (user, role) {
  try {
    return user.role_id == role
  } catch (err) {
    return false
  }
}

export function isAdmin (user) {
  return checkRole(user, 1)
}

export function isManager (user) {
  return checkRole(user, 2)
}

export function isStudent (user) {
  return checkRole(user, 3)
}

export function isProfessional (user) {
  return checkRole(user, 4)
}

export function hasInBetweenPrivileges (user) {
  return isProfessional(user) || isStudent(user) || isManager(user)
}

export function isRecipient (user) {
  return checkRole(user, 5)
}

export function isCurrentUser (user, current) {
  return user && current && user.id == current.id
}



// WEBPACK FOOTER //
// ./resources/js/plugins/auth.js